import * as contributionLib from "@taabl/common-lib/calculators/contribution";
export function floorToDigits(value, digits = 2) {
  return Math.floor(value * Math.pow(10, digits)) / Math.pow(10, digits);
}
export const calculateEquivalentShares =
  contributionLib.calculateEquivalentShares;

// This function is used to calculate fair value
export const calculateFairValue = contributionLib.calculateFairValue;

// this function returns the actual shares purchased without applying any settings
export const calculatePurchaseShares = contributionLib.calculatePurchaseShares;
//this function returns purchase periods as single array
export function getPurchasePeriodsAsArray(data, returnAsSingleArray = true) {
  let resultContributionArray = [];
  for (let key in data) {
    if (key.startsWith("pp_")) {
      let currentPeriod = data[key];
      if (returnAsSingleArray) {
        resultContributionArray = [
          ...resultContributionArray,
          ...currentPeriod,
        ];
      } else {
        resultContributionArray.push(currentPeriod);
      }
    }
  }

  return resultContributionArray;
}

// This function is used to calculate stats for employee by period
export const calcStatsByPeriod = contributionLib.calculatePeriodwiseProfits;
//this function calculates the taabl refund due
export const calcuateTaablRefundDue = contributionLib.calcuateTaablRefundDue;
//this function calculates taxes
export const calculateTaxes = contributionLib.calculateTaxes;

// This function is used to calcuate contribution stat like deduction, profit etc
export const calculateContributionStat =
  contributionLib.calculateContributionStat;
export const calculateMaxContribution =
  contributionLib.calculateMaxContribution;
